import {
  Button,
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  useDisclosure,
  Grid,
  Flex,
  Text,
  useToast,
} from '@chakra-ui/react'
import React from 'react'
import { DragAndDrop } from '../../../components/DragAndDrop'
import { useForm } from 'react-hook-form'
import { api } from '../../../services/api'
import { useMutation, useQueryClient } from 'react-query'
import { z } from 'zod'
import { zodResolver } from '@hookform/resolvers/zod'

const baseIlustracoesSchema = z.array(
  z.object({
    id: z.number(),
    link: z.string(),
  })
)

const ACCEPTED_IMAGE_TYPES = ['image/png']

const uploadSchema = z.object({
  arquivo: z.any().refine((file) => ACCEPTED_IMAGE_TYPES.includes(file?.type), 'Formato inválido. Apenas PNG é permitido.'),
})

async function updateBaseIlsutracao({ numero_nota, codigo_produto, id }) {
  const res = await api.put('/site/v2/fluxo-layout/atualiza-base-ilustracao', {
    numero_nota,
    codigo_produto,
    id,
  })

  return res.data
}

async function uploadNewBaseIlustracao(data) {
  const res = await api.post('/site/v2/fluxo-layout/subir-nova-base-ilustracao', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })

  return res.data
}

export const ModalBaseIlustracoes = ({ baseIlustracoes, item }) => {
  const [baseLayout, setBaseLayout] = React.useState(null)

  const [selectedBase, setSelectedBase] = React.useState(null)

  const { isOpen, onOpen, onClose } = useDisclosure()
  const btnRef = React.useRef()

  const queryClient = useQueryClient()

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: 'onChange',
    resolver: zodResolver(uploadSchema),
  })

  console.log(errors)

  const toast = useToast({
    position: 'top-right',
    duration: 3000,
    isClosable: true,
  })

  const { mutateAsync: saveBaseLayout, isLoading } = useMutation({
    mutationFn: updateBaseIlsutracao,
    onSuccess: (data) => {
      toast({
        title: 'Sucesso',
        description: 'Base de ilustração atualizada com sucesso',
        status: 'success',
      })

      setBaseLayout(selectedBase)
      setSelectedBase(null)

      onClose()
    },

    onError: () => {
      toast({
        title: 'Erro',
        description: 'Erro ao atualizar a base de ilustração',
        status: 'error',
      })
    },
  })

  const { mutateAsync: uploadBaseIlustracao, isLoading: uploadNewBaseLoading } = useMutation({
    mutationFn: uploadNewBaseIlustracao,
    onSuccess: (data) => {
      toast({
        title: 'Sucesso',
        description: 'Base de ilustração enviada com sucesso',
        status: 'success',
      })

      queryClient.invalidateQueries('info-solicitacao-layout')
    },

    onError: () => {
      toast({
        title: 'Erro',
        description: 'Erro ao enviar a base de ilustração',
        status: 'error',
      })
    },
  })

  async function handleUploadBaseIlustracao(data) {
    const formData = new FormData()

    formData.append('arquivo', data.arquivo)
    console.log(Object.fromEntries(formData))

    await uploadBaseIlustracao(formData)

    queryClient.invalidateQueries('fluxo-layout')
  }

  async function handleSaveBase() {
    if (!selectedBase) {
      return
    }

    await saveBaseLayout({
      numero_nota: parseInt(item.numero_nota),
      codigo_produto: parseInt(item.codigo_produto),
      id: selectedBase.id,
    })
  }

  function handleSelectBase(base) {
    setSelectedBase(base)
  }

  function handleOpenModal() {
    if (baseLayout) {
      setSelectedBase(baseLayout)
    }

    onOpen()
  }

  return (
    <>
      <Button
        variant="outline"
        onClick={handleOpenModal}
        size="sm"
        px={4}
        fontSize="sm"
        borderRadius="sm"
        _hover={{
          filter: 'brightness(0.8)',
        }}
      >
        {baseLayout ? 'Base selecionada' : 'Selecionar base de ilustração'}
      </Button>

      <Drawer isOpen={isOpen} size="lg" placement="right" onClose={onClose} finalFocusRef={btnRef}>
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader>Selecione a base de ilustração desejada!</DrawerHeader>

          <DrawerBody>
            <Grid templateColumns="repeat(3, 1fr)" gap={6}>
              {baseIlustracoes.map((item) => (
                <Flex key={item.id} flexDirection="column" alignItems="center" justifyContent="center">
                  <img src={item.link} alt={item.id} />
                  <Button variant={selectedBase?.id === item.id ? 'solid' : 'outline'} size="sm" mt={2} onClick={() => handleSelectBase(item)}>
                    {selectedBase?.id === item.id ? 'Selecionado' : 'Selecionar'}
                  </Button>
                </Flex>
              ))}
            </Grid>

            <Flex flexDirection="column" gap={4} mt={4}>
              <Text fontSize="md" color="gray.600" textAlign="center" fontWeight="bold">
                Ou faça o upload de uma nova base para ilustração
              </Text>

              <form onChange={handleSubmit(handleUploadBaseIlustracao)}>
                <DragAndDrop control={control} name="arquivo" />
                {errors.arquivo && <Text color="red.500">{errors.arquivo.message}</Text>}
              </form>
            </Flex>
          </DrawerBody>

          <DrawerFooter>
            <Button variant="outline" mr={3} onClick={onClose}>
              Cancelar
            </Button>
            <Button colorScheme="blue" onClick={handleSaveBase} isLoading={isLoading} loadingText="Salvando">
              Salvar
            </Button>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </>
  )
}
